import component from './i18nLabels.vue'

export default component
